import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { defaultGetAuthorizationsAsync } from "./Auth/defaultGetAuthorizationsAsync";
import App from "./App";
import "./errorReporting";

ReactDOM.render(
  <Router>
    <App getAuthorizationsAsync={defaultGetAuthorizationsAsync} />
  </Router>,
  document.getElementById("root")
);
